//import * as React from "react";
import React, { useRef, useEffect, useState } from "react";

import CirculoCaries from "./CirculoCaries"
import CirculoCaries2 from "./CirculoCaries2"


//{ "pieza":12, id_prod :0, color:"white", partes:  "00000", interno: false},
//{pieza: 11, id_prod: 0, color: 'white', partes: '00000', interno: false}
//------parametros inicializados

const RenderCaries = ({ data=[] }) => {
  //"#fff"
  //let color= props.color || '#fff';
  console.log('data');
  //console.log(data);
   
  return (
    <span>
    { data.map((item,index) =>(
      <div key={index}>
        {item.pieza=== 18 && 
        <CirculoCaries2 pieza={18} value={item.partes}  width={38} height={47} style={{top: '260', left: '10' }} className="di" soloLectura={true} />          
        }
        {item.pieza=== 17 && 
        <CirculoCaries2 pieza={17} value={item.partes} width={38} height={47} style={{top: '220', left: '17' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 16 && 
        <CirculoCaries2 pieza={16} value={item.partes} width={38} height={47} style={{top: '176', left: '22' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 15 &&
        <CirculoCaries2 pieza={15} value={item.partes} width={38} height={47} style={{top: '132', left: '28' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 14 &&
        <CirculoCaries2 pieza={14} value={item.partes} width={38} height={47} style={{top: '92', left: '34' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 13 &&
        <CirculoCaries2 pieza={13} value={item.partes} width={38} height={47} style={{top: '46', left: '51' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 12 &&
        <CirculoCaries2 pieza={12} value={item.partes} width={38} height={47} style={{top: '7', left: '98' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 11 &&
        <CirculoCaries2 pieza={11} value={item.partes} width={38} height={47} style={{top: '-4', left: '136' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 21 &&
        <CirculoCaries2 pieza={21} value={item.partes} width={38} height={47} style={{top: '-4', left: '169' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 22 &&
        <CirculoCaries2 pieza={22} value={item.partes} width={38} height={47} style={{top: '10', left: '213' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 23 &&
        <CirculoCaries2 pieza={23} value={item.partes} width={38} height={47} style={{top: '42', left: '250' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 24 &&
        <CirculoCaries2 pieza={24} value={item.partes} width={38} height={47} style={{top: '90', left: '267' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 25 &&
        <CirculoCaries2 pieza={25} value={item.partes} width={38} height={47} style={{top: '129', left: '277' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 26 &&
        <CirculoCaries2 pieza={26} value={item.partes} width={38} height={47} style={{top: '172', left: '284' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 27 &&
        <CirculoCaries2 pieza={27} value={item.partes} width={38} height={47} style={{top: '217', left: '290' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 28 &&
        <CirculoCaries2 pieza={28} value={item.partes} width={38} height={47} style={{top: '262', left: '297' }} className="di" soloLectura={true}  />
        }
        {/**----------------- parte de abajo ------------------------------------------------- */}
        {item.pieza=== 48 &&
        <CirculoCaries2 pieza={48} value={item.partes} width={38} height={47} style={{top: '74', left: '325' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 47 &&
        <CirculoCaries2 pieza={47} value={item.partes} width={38} height={47} style={{top: '121', left: '331' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 46 &&
        <CirculoCaries2 pieza={46} value={item.partes} width={38} height={47} style={{top: '168', left: '339' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 45 &&
        <CirculoCaries2 pieza={45} value={item.partes} width={38} height={47} style={{top: '211', left: '350' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 44 &&
        <CirculoCaries2 pieza={44} value={item.partes} width={38} height={47} style={{top: '255', left: '360' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 43 &&
        <CirculoCaries2 pieza={43} value={item.partes} width={38} height={47} style={{top: '302', left: '380' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 42 &&
        <CirculoCaries2 pieza={42} value={item.partes} width={38} height={47} style={{top: '332', left: '420' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 41 &&
        <CirculoCaries2 pieza={41} value={item.partes} width={38} height={47} style={{top: '340', left: '452' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 31 &&
        <CirculoCaries2 pieza={31} value={item.partes} width={38} height={47} style={{top: '340', left: '487' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 32 &&
        <CirculoCaries2 pieza={32} value={item.partes} width={38} height={47} style={{top: '332', left: '520' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 33 &&
        <CirculoCaries2 pieza={33} value={item.partes} width={38} height={47} style={{top: '305', left: '555' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 34 &&
        <CirculoCaries2 pieza={34} value={item.partes} width={38} height={47} style={{top: '255', left: '577' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 35 &&
        <CirculoCaries2 pieza={35} value={item.partes} width={38} height={47} style={{top: '213', left: '586' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 36 &&
        <CirculoCaries2 pieza={36} value={item.partes} width={38} height={47} style={{top: '167', left: '597' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 37 &&
        <CirculoCaries2 pieza={37} value={item.partes} width={38} height={47} style={{top: '121', left: '602' }} className="di" soloLectura={true}  />
        }
        {item.pieza=== 38 &&
        <CirculoCaries2 pieza={38} value={item.partes} width={38} height={47} style={{top: '77', left: '606' }} className="di" soloLectura={true}  />
        }
      </div>
      ))}
  </span>
)};
export default RenderCaries;